<template xmlns:color="http://www.w3.org/1999/xhtml">
  <div class="row">
    <!--  申请用户信息  -->
    <div class="flex xs10 offset--xs1">
      <va-card title="申请用户信息">
        <va-button flat disabled color="red">开始时间和结束时间均为运营人员本地的时区，并不是用户的时区</va-button>
        <div class="row">
          <div class="flex md6 sm6 xs12">
            <va-input
              label="学员uid"
              v-model="insertData.user.uid"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              label="学员姓名"
              v-model="insertData.user.nickname"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              label="联系方式"
              v-model="insertData.contactInfo"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="申请提交时间"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.question"
              label="问题"
              disabled
            />
          </div>
                    <div class="flex md6 sm6 xs12">
            <va-input
              label="导师时区"
              v-model="insertData.mentorTimeZone"
              disabled
            />
          </div>
                    <div class="flex md6 sm6 xs12">
            <va-input
              label="用户时区"
              v-model="insertData.userTimeZone"
              disabled
            />
          </div>
                    <div class="flex md6 sm6 xs12">
            <va-input
              label="开始时间"
              v-model="insertData.startTime"
              disabled
            />
          </div>
                    <div class="flex md6 sm6 xs12">
            <va-input
              label="结束时间"
              v-model="insertData.endTime"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.status"
              label="处理状态"
              :options="statusOptions"
              no-clear
            />
          </div>
        </div>
        <div class="row justify--center">
<!--          <div class="flex md2">
            <va-button class="ma-0" color="primary" slot="trigger" @click="$router.push({ path: `/admin/users/updateUser/${insertData.user.uid}` })">
              查看用户信息
            </va-button>
          </div>-->
          <div class="flex md2">
            <va-button class="ma-0" color="primary" slot="trigger" @click="processAppliedConsulting" :disabled="!submitButtonStatus">
              保存
            </va-button>
          </div>
          <div class="flex md2">
            <va-button class="ma-0" color="gray" slot="trigger" @click="$router.push({ name: 'listAppliedConsulting' })">
              返回
            </va-button>
          </div>
        </div>
      </va-card>
    </div>
    <div class="flex xs10 offset--xs1">
      <va-card title="咨询信息">
        <div class="row">
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='insertData.consulting.uid'
              label='id'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.consulting.topic"
              label="咨询话题"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.consulting.mentorNickname"
              label="咨询导师"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.consulting.price"
              label="价格"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.consulting.duration"
              label="时长"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.consulting.description"
              label="话题详情"
              disabled
            />
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject, formatTime } from '../../../utils/common'
import appliedConsultingApi from '../../../api/appliedConsulting'
import { USER_APPLICATION_STATUS_TYPES } from '../../../utils/constants'

export default {
  data () {
    return {
      insertData: {
        id: null,
        question: '',
        contactInfo: '',
        createTime: '',
        consulting: {},
        user: {},
        status: '',
        userTimeZone: '',
        mentorTimeZone: '',
        startTime: '',
        endTime: '',
      },
      message: ['Required field'],
      title: '',
      statusOptions: USER_APPLICATION_STATUS_TYPES.map(x => { return x.TEXT }),
      submitButtonStatus: true,
    }
  },
  created () {
    this.getAppliedConsulting()
  },
  computed: {

  },
  methods: {
    getAppliedConsulting () {
      const params = this.$route.params
      if (params.id != null) {
        this.title = '申请职位详情'
        // 通过id获取详情
        appliedConsultingApi.getAppliedConsulting(params.id).then(response => {
          copyObject(response.appliedConsulting, this.insertData)
          this.insertData.createTime = formatTime(this.insertData.createTime)
          this.insertData.startTime = formatTime(this.insertData.startTime)
          this.insertData.endTime = formatTime(this.insertData.endTime)
          this.computeCodeToStatus(response.appliedConsulting.status)
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    processAppliedConsulting () {
      this.changeButtonStatus(false)
      const data = {
        id: this.insertData.id,
        status: this.computeStatusToCode(this.insertData.status),
      }
      appliedConsultingApi.processAppliedConsulting(data.id, data).then(response => {
        if (response.success === true) {
          this.changeButtonStatus(true)
          this.showToast('更新处理状态成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.getAppliedConsulting()
        }
      }).catch(error => {
        this.changeButtonStatus(true)
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    computeCodeToStatus (code) {
      USER_APPLICATION_STATUS_TYPES.map(x => {
        if (x.CODE === code) {
          this.insertData.status = x.TEXT
        }
      })
    },
    computeStatusToCode (status) {
      let code = -1
      USER_APPLICATION_STATUS_TYPES.map(x => {
        if (x.TEXT === status) {
          code = x.CODE
        }
      })
      return code
    },
    resetStatus () {
    },
    clickCancel () {
    },
    checkField () {
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
